import React from 'react';

const IconTabletScreen: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    height='16'
    width='16'
    viewBox='0 0 448 512'
    focusable='false'
    role='presentation'
    fill='none'
    {...props}
    className={`icon icon-tablet-screen${props.className ? ' ' + props.className : ''}`}
  >
    <path
      d='M0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM256 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 64L64 64l0 320 320 0 0-320z'
      fill=''
    ></path>
  </svg>
);
export default IconTabletScreen;
